import styled from "styled-components"
import { Container } from "../../../components/navbar/Nav.styles"
import { ProductCaptionText } from "../../home/components/OurProduct"

const Team = () => {
    return (
      <TeamContainer>
        <Container>
          <TeamCaptionText>Our Team</TeamCaptionText>
          <TeamBody>
            <TeamContent>
              <div>
                <img
                  src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1653626922/invest-trust/Ellipse_41_pf90ym.png"
                  alt="Managing Director"
                />
              </div>
              <h4>Ifeoma Okafor</h4>
              <h4>Managing Director</h4>
            </TeamContent>
            <TeamContent>
              <div>
                <img
                  src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1653626922/invest-trust/Ellipse_42_yizabl.png"
                  alt="Head of HR"
                />
              </div>
              <h4>Zino Adewale</h4>
              <h4>Head of HR</h4>
            </TeamContent>
            <TeamContent>
              <div>
                <img
                  src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1653626922/invest-trust/Ellipse_40_ptwttd.png"
                  alt="Customer Satisfaction
                        Manager"
                />
              </div>
              <h4>Olaitan Atose</h4>
              <h4 className="office__position">Customer Satisfaction Manager</h4>
            </TeamContent>
          </TeamBody>
        </Container>
      </TeamContainer>
    );
}

export default Team

export const TeamContainer = styled.div`
   background-color: #F1F1FE;
   padding-bottom: 6rem;
`
export const TeamCaptionText = styled(ProductCaptionText)`
  text-align: right;
  padding-top: 2rem;
//   margin-bottom: 2rem;
  @media screen and (max-width: 991px) {
    text-align: center;
  }
`;
export const TeamBody = styled.div`
margin-left: 10rem;
margin-right: 10rem;
  transform: translateY(-2rem);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 56px;

  img {
    max-width: 100%;
    border-radius: 50%;
  }
  @media screen and (max-width: 991px) {
    margin-top: 6rem;
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 579px) {
    margin-top: 7rem;
    grid-template-columns: 1fr;
    gap: 3rem;
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

export const TeamContent = styled.div`
    background: #fff;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div {
        padding-top: 2rem;
    }

     h4:nth-of-type(1) {
        // border: 4px solid red;
        margin-top: 0rem;
        margin-bottom: 0rem;
        font-size: 20px;
    }
     h4:nth-of-type(2) {
        color: ${({ theme }) => theme.colors.secondary};
        margin-top: 0rem;
        font-size: 20px;
    }

    .office__position{
        width: 80%;
        text-align: center;
    }
    

`;